/* Copyright 2013 - 2022 Waiterio LLC */
import React from 'react'
import { Provider } from '@waiterio/context/index.js'
import GlobalStyles from '@waiterio/components/GlobalStyles.js'
import StageBadge from '@waiterio/components/StageBadge.js'
import Routes from './Routes.js'

export default ({ initialContext }) => (
  <>
    <GlobalStyles />
    <Provider initialContext={initialContext}>
      <Routes />
    </Provider>
    <StageBadge />
  </>
)
